import { oz } from '@weft/utils';
import { RevenueBreakdownSchema } from '../revenue-breakdown';
import { NewCustomerSchema } from './new-customer-schema';

export const UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT = Object.freeze({
  details: 'details',
  address: 'address',
  settings: 'settings',
  contacts: 'contacts',
  none: 'none',
});

export type UpdateCustomerSectionToSubmit = keyof typeof UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT;

export const UpdateCustomerSchema = NewCustomerSchema.extend({
  name: oz.string().nonempty().optional(),
  sectionToSubmit: oz.nativeEnum(UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT),
  revenueBreakdown: RevenueBreakdownSchema.optional(),
});

export type UpdateCustomer = oz.infer<typeof UpdateCustomerSchema>;